import { XIcon } from "@phosphor-icons/react";
import { useT } from "@transifex/react";
import type { ReactNode } from "react";
import Modal from "react-modal";
import { getModalStyles } from "../../basic/popups/BasePopupWrapper";

interface AnonymousFlowPopupFrameProps {
    isOpen: boolean;
    onClose: () => void;
    isSubmitting?: boolean;
    titleId: string;
    children: ReactNode;
    "data-testid"?: string;
}

const baseModalStyles = getModalStyles(430);
const modalStyles: Modal.Styles = {
    overlay: baseModalStyles.overlay,
    content: { ...baseModalStyles.content, width: "100%", border: "none", borderRadius: "20px" },
};

const AnonymousFlowPopupFrame = (props: AnonymousFlowPopupFrameProps) => {
    const t = useT();
    const t_sr_close = t("Close", { _tags: "CreateTest, AnonymousSavePopup, ScreenReaderOnly" });

    const handleClose = () => {
        if (!props.isSubmitting) props.onClose();
    };

    return (
        <Modal
            isOpen={props.isOpen}
            onRequestClose={handleClose}
            style={modalStyles}
            aria={{ labelledby: props.titleId }}
            ariaHideApp={false}
        >
            <div
                data-testid={props["data-testid"]}
                className="relative flex flex-col gap-m p-m"
            >
                <button
                    type="button"
                    onClick={handleClose}
                    disabled={props.isSubmitting}
                    aria-label={t_sr_close}
                    className="absolute top-s right-s flex items-center justify-center w-[32px] h-[32px] rounded-circle bg-transparent border-none text-p6-grey-mid cursor-pointer enabled:hover:text-p6-grey-dark disabled:cursor-not-allowed"
                >
                    <XIcon
                        size={22}
                        aria-hidden="true"
                    />
                </button>
                {props.children}
            </div>
        </Modal>
    );
};

export default AnonymousFlowPopupFrame;
